import { useEffect, useRef } from "react";
import { motion } from 'framer-motion'
import { twMerge } from "tailwind-merge";

export function HeatMapColor({ row, column, props, hour }) {
  const hasLoaded = useRef(false);
  useEffect(() => {
    if (props.loading) hasLoaded.current = true;
  }, []);

  const firstLoad = !props.loading && !hasLoaded.current
  const delay = firstLoad ? 0 : (row * 0.1) + (column * 0.05)
  const duration = firstLoad ? 0 : 1

  return (
    <motion.span
      key={`${props.date}-${hour}`}
      variants={{
        loading: {
          background: "#eeeeee",
        },
        loaded: {
          background: props.blocks?.[hour]?.background,

        }
      }}
      animate={props.loading ? "loading" : "loaded"}
      initial={firstLoad ? "loaded" : "loading"}
      transition={{
        duration,
        delay
      }}
      className={twMerge(
        "w-full h-full group-hover/content:opacity-50 transition-all duration-700 group-data-[row=true]/cell:duration-200 group-data-[col=true]/cell:duration-200 group-data-[row=true]/cell:!opacity-100 group-data-[col=true]/cell:!opacity-100",
      )}
    />
  );
}
